module.exports = __webpack_public_path__ + "static/service4-716204b1bd39067f0f9dbfec9a7b8595.png";